// src/routes/departmentsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Departments from '../pages/departments/Departments';
import CreateDepartments from '../pages/departments/CreateDepartments';
import EditDepartments from '../pages/departments/EditDepartments';
import ProtectedRoute from '../components/global/ProtectedRoute';

const departmentsRoutes = (
    <>
        {/* Departments List */}
        <Route
            path="/departments"
            element={
                <ProtectedRoute requiredPermission="departments_list">
                    <Departments />
                </ProtectedRoute>
            }
        />

        {/* Create Department */}
        <Route
            path="/departments/create"
            element={
                <ProtectedRoute requiredPermission="departments_create">
                    <CreateDepartments />
                </ProtectedRoute>
            }
        />

        {/* Edit Department */}
        <Route
            path="/departments/:id/edit"
            element={
                <ProtectedRoute requiredPermission="departments_edit">
                    <EditDepartments />
                </ProtectedRoute>
            }
        />
    </>
);

export default departmentsRoutes;
